  import { Component, ElementRef, Inject, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, AbstractControl, FormControl} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Interface for time range
interface TimeRange {
	hour: number;
	minute: number;
	period: 'AM' | 'PM';
	endHour: number;
	endMinute: number;
	endPeriod: 'AM' | 'PM';
	start: Date;
	end: Date;
	startTime: string;
	endTime: string;
}

// Interface for operating hours entry
interface OperatingHoursEntry {
	selectedDays: string[];
	timeRanges: TimeRange[];
}
  @Component({
    selector: 'partner-mart-create-store-multistep',
    standalone: true,
    imports: [
      CommonModule,
      ReactiveFormsModule,
      MatStepperModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule,
      MatIconModule,
      MatDialogModule,
      MatListModule,
      MatTabsModule,
      MatChipsModule,
      MatDatepickerModule,
      MatButtonToggleModule,
      MatSelectModule,
      CalendarModule,
      FormsModule

    ],
    templateUrl: './store-operation-hours.component.html',
    styleUrls: ['./store-operation-hours.component.scss', '../../../../../../styles/m3-defaul-material-theme.scss'],
  })

  export class StoreOperationHoursDialogComponent implements OnInit {
    constructor(
  @Inject(MAT_DIALOG_DATA) public data: {
    savedHours: TimeRange[];
    savedOperationHours: OperatingHoursEntry[];
    existingOperationHours?: OperatingHoursEntry[];
  },
  private dialogRef: MatDialogRef<StoreOperationHoursDialogComponent>
) {}

    weekDays = [
      { name: 'Sun', selected: false },
      { name: 'Mon', selected: true },
      { name: 'Tue', selected: true },
      { name: 'Wed', selected: true },
      { name: 'Thur', selected: true },
      { name: 'Fri', selected: true },
      { name: 'Sat', selected: false }
    ];


    ngOnInit(): void {
      // If we have saved hours, use those; otherwise, ensure default times are properly set
      if (this.data?.savedHours && this.data.savedHours.length > 0) {
        this.timeRanges = [...this.data.savedHours]; // restore all including start/end
      } else {
        // Reset all days to unselected for new entries
        this.weekDays.forEach(day => {
          day.selected = false;
        });

        // Ensure default times are properly set for new entries
        this.timeRanges.forEach(range => {
          // Set the start time to 9:00 AM
          const startDate = new Date();
          startDate.setHours(9, 0, 0, 0);
          range.start = startDate;

          // Set the end time to 5:00 PM
          const endDate = new Date();
          endDate.setHours(17, 0, 0, 0);
          range.end = endDate;

          // Update the display properties to match
          range.hour = 9;
          range.minute = 0;
          range.period = 'AM';
          range.startTime = '09:00 AM';

          range.endHour = 5;
          range.endMinute = 0;
          range.endPeriod = 'PM';
          range.endTime = '05:00 PM';

          // Ensure all properties are synchronized

        });
      }

      // Ensure all time ranges have synchronized properties
      this.synchronizeTimeRangeProperties();
    }

    // Helper method to ensure all time range properties are synchronized
    private synchronizeTimeRangeProperties(): void {
      this.timeRanges.forEach((tr, index) => {
        // If startTime is set but hour/minute/period are not synchronized, update them
        if (tr.startTime && (!tr.hour || tr.hour === 0)) {
          const timeMatch = tr.startTime.match(/(\d+):(\d+)\s*(AM|PM)/);
          if (timeMatch) {
            tr.hour = parseInt(timeMatch[1], 10);
            tr.minute = parseInt(timeMatch[2], 10);
            tr.period = timeMatch[3] as 'AM' | 'PM';
          }
        }

        // If endTime is set but endHour/endMinute/endPeriod are not synchronized, update them
        if (tr.endTime && (!tr.endHour || tr.endHour === 0)) {
          const timeMatch = tr.endTime.match(/(\d+):(\d+)\s*(AM|PM)/);
          if (timeMatch) {
            tr.endHour = parseInt(timeMatch[1], 10);
            tr.endMinute = parseInt(timeMatch[2], 10);
            tr.endPeriod = timeMatch[3] as 'AM' | 'PM';
          }
        }
      });
    }

  save(): void {
  // Check for overlaps before saving
  if (this.wouldCreateTimeOverlap()) {
    // Overlap detected - save button should be disabled in UI
    return;
  }

  // Ensure all properties are synchronized before saving
  this.synchronizeTimeRangeProperties();

  this.savedOperationHours = this.timeRanges.map(tr => ({
    hour: tr.hour,
    minute: tr.minute,
    period: tr.period,
    endHour: tr.endHour,
    endMinute: tr.endMinute,
    endPeriod: tr.endPeriod,
    start: tr.start,
    end: tr.end,
    startTime: tr.startTime,
    endTime: tr.endTime
  }));

  // Get selected days
  const selectedDays = this.weekDays.filter(day => day.selected).map(day => day.name);

  // Create the complete data object with both time ranges and selected days
  const completeData = {
    timeRanges: this.savedOperationHours,
    selectedDays
  };

  this.dialogRef.close(completeData);
}

    date3: Date = new Date();
    startTime: Date = new Date();
    endTime: Date = new Date();

  getHours(date: Date): string {
    return ((date.getHours() % 12) || 12).toString();
  }

  getMinutes(date: Date): string {
    return date.getMinutes().toString().padStart(2, '0');
  }

  timeRanges: TimeRange[] = [
    {
      hour: 9,
      minute: 0,
      period: 'AM',
      endHour: 5,
      endMinute: 0,
      endPeriod: 'PM',
      start: (() => {
        const date = new Date();
        date.setHours(9, 0, 0, 0);
        return date;
      })(),
      end: (() => {
        const date = new Date();
        date.setHours(17, 0, 0, 0);
        return date;
      })(),
      startTime: '09:00 AM',
      endTime: '05:00 PM'
    }
  ];

  timeOptions: { value: string; display: string }[] = [
    { value: '12:00 AM', display: '12:00 AM' },
    { value: '12:30 AM', display: '12:30 AM' },
    { value: '01:00 AM', display: '01:00 AM' },
    { value: '01:30 AM', display: '01:30 AM' },
    { value: '02:00 AM', display: '02:00 AM' },
    { value: '02:30 AM', display: '02:30 AM' },
    { value: '03:00 AM', display: '03:00 AM' },
    { value: '03:30 AM', display: '03:30 AM' },
    { value: '04:00 AM', display: '04:00 AM' },
    { value: '04:30 AM', display: '04:30 AM' },
    { value: '05:00 AM', display: '05:00 AM' },
    { value: '05:30 AM', display: '05:30 AM' },
    { value: '06:00 AM', display: '06:00 AM' },
    { value: '06:30 AM', display: '06:30 AM' },
    { value: '07:00 AM', display: '07:00 AM' },
    { value: '07:30 AM', display: '07:30 AM' },
    { value: '08:00 AM', display: '08:00 AM' },
    { value: '08:30 AM', display: '08:30 AM' },
    { value: '09:00 AM', display: '09:00 AM' },
    { value: '09:30 AM', display: '09:30 AM' },
    { value: '10:00 AM', display: '10:00 AM' },
    { value: '10:30 AM', display: '10:30 AM' },
    { value: '11:00 AM', display: '11:00 AM' },
    { value: '11:30 AM', display: '11:30 AM' },
    { value: '12:00 PM', display: '12:00 PM' },
    { value: '12:30 PM', display: '12:30 PM' },
    { value: '01:00 PM', display: '01:00 PM' },
    { value: '01:30 PM', display: '01:30 PM' },
    { value: '02:00 PM', display: '02:00 PM' },
    { value: '02:30 PM', display: '02:30 PM' },
    { value: '03:00 PM', display: '03:00 PM' },
    { value: '03:30 PM', display: '03:30 PM' },
    { value: '04:00 PM', display: '04:00 PM' },
    { value: '04:30 PM', display: '04:30 PM' },
    { value: '05:00 PM', display: '05:00 PM' },
    { value: '05:30 PM', display: '05:30 PM' },
    { value: '06:00 PM', display: '06:00 PM' },
    { value: '06:30 PM', display: '06:30 PM' },
    { value: '07:00 PM', display: '07:00 PM' },
    { value: '08:00 PM', display: '08:00 PM' },
    { value: '09:00 PM', display: '09:00 PM' },
    { value: '10:00 PM', display: '10:00 PM' },
    { value: '11:00 PM', display: '11:00 PM' },
    { value: '11:30 PM', display: '11:30 PM' }
  ];
  savedOperationHours: TimeRange[] = [];

  addTimeRange() {
    // Create default start time (9:00 AM)
    const startDate = new Date();
    startDate.setHours(9, 0, 0, 0);

    // Create default end time (5:00 PM)
    const endDate = new Date();
    endDate.setHours(17, 0, 0, 0);

    const newRange = {
      hour: 9,
      minute: 0,
      period: 'AM' as 'AM' | 'PM',
      endHour: 5,
      endMinute: 0,
      endPeriod: 'PM' as 'AM' | 'PM',
      start: startDate,
      end: endDate,
      startTime: '09:00 AM',
      endTime: '05:00 PM'
    };

    this.timeRanges = [...this.timeRanges, newRange];

    // Ensure the new time range has synchronized properties
    this.synchronizeTimeRangeProperties();
  }

  removeTimeRange(index: number) {
    // Prevent removing the last time range if it's the only one
    if (this.timeRanges.length <= 1) {
      return;
    }

    // Remove the time range at the specified index
    this.timeRanges = this.timeRanges.filter((_, i) => i !== index);

    // Ensure remaining time ranges have synchronized properties
    this.synchronizeTimeRangeProperties();
  }

  getAmPm(date: Date | null): string {
    if (!date) {return '';}
    const hours = date.getHours();
    return hours >= 12 ? 'PM' : 'AM';
    }

  get12Hour(date: Date): number {
    const hour = date.getHours();
    return hour % 12 === 0 ? 12 : hour % 12;
  }

  getPeriod(date: Date): 'AM' | 'PM' {
    return date.getHours() >= 12 ? 'PM' : 'AM';
  }

  onHourChange(index: number): void {
    const range = this.timeRanges[index];
    const date = new Date(range.start);
    const currentHour = date.getHours();
    const isPM = currentHour >= 12;

    const hour24 = (range.hour % 12) + (isPM ? 12 : 0);
    date.setHours(hour24);
    this.timeRanges[index].start = date;
  }

  onMinuteChange(index: number): void {
    const range = this.timeRanges[index];
    const date = new Date(range.start);
    date.setMinutes(range.minute);
    this.timeRanges[index].start = date;
  }

  onPeriodChange(index: number) {
    const tr = this.timeRanges[index];
    // Create a new date to avoid mutating the existing one
    const newDate = new Date(tr.start);
    newDate.setHours(this.to24Hour(tr.hour, tr.period));
    tr.start = newDate;
  }

  to24Hour(hour: number, period: 'AM' | 'PM'): number {
    if (period === 'PM' && hour < 12) {
      return hour + 12;
    }
    if (period === 'AM' && hour === 12) {
      return 0;
    }
    return hour;
  }

  onManualTimeChange(index: number) {
    const time = this.timeRanges[index];
    let hour = time.hour % 12;

    // Apply AM/PM
    if (time.period === 'PM') {
      hour += 12;
    }

    // Always create a new date based on the existing start time to preserve the date
    const newDate = new Date(time.start);
    newDate.setHours(hour);
    newDate.setMinutes(time.minute);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);

    this.timeRanges[index].start = newDate;
  }

  onCalendarChange(timeRange: any, index: number) {
    const date = timeRange.start;
    if (!date) {
      return;
    }
    timeRange.hour = this.get12Hour(date);
    timeRange.minute = date.getMinutes();
    timeRange.period = this.getPeriod(date);
  }

  //end time
  onManualEndTimeChange(index: number) {
    const range = this.timeRanges[index];
    let hour = range.endHour % 12;
    if (range.endPeriod === 'PM') {
      hour += 12;
    }
    // Always create a new date based on the existing end time to preserve the date
    const newDate = new Date(range.end);
    newDate.setHours(hour);
    newDate.setMinutes(range.endMinute);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);

    this.timeRanges[index].end = newDate;
  }

  onCalendarEndChange(timeRange: any, index: number) {
    const date = timeRange.end;
    if (!date) {
      return;
    }
    timeRange.endHour = this.get12Hour(date);
    timeRange.endMinute = date.getMinutes();
    timeRange.endPeriod = this.getPeriod(date);
  }

  toggleDay(index: number) {
    const day = this.weekDays[index];

    // Check if this day would create an overlap
    if (!day.selected && this.wouldCreateDayOverlap(day.name)) {
      // Prevent selection of conflicting days
      return;
    }

    this.weekDays[index].selected = !this.weekDays[index].selected;
  }

  // Check if selecting a day would create an overlap with existing operation hours
  wouldCreateDayOverlap(dayName: string): boolean {
    if (!this.data?.existingOperationHours) {
      return false;
    }

    return this.data.existingOperationHours.some(entry =>
      entry.selectedDays.includes(dayName)
    );
  }

  // Check if a day is already used in existing operation hours
  isDayAlreadyUsed(dayName: string): boolean {
    return this.wouldCreateDayOverlap(dayName);
  }

  // Check if current time ranges would overlap with existing ones for selected days
  wouldCreateTimeOverlap(): boolean {
    if (!this.data?.existingOperationHours) {
      return false;
    }

    const selectedDays = this.weekDays.filter(day => day.selected).map(day => day.name);

    for (const day of selectedDays) {
      // Find existing entries that use this day
      const existingEntriesForDay = this.data.existingOperationHours.filter(entry =>
        entry.selectedDays.includes(day)
      );

      for (const existingEntry of existingEntriesForDay) {
        for (const existingTimeRange of existingEntry.timeRanges) {
          for (const currentTimeRange of this.timeRanges) {
            if (this.timeRangesOverlap(currentTimeRange, existingTimeRange)) {
              return true;
            }
          }
        }
      }
    }

    return false;
  }

  // Check if two time ranges overlap
  private timeRangesOverlap(range1: TimeRange, range2: TimeRange): boolean {
    if (!range1.startTime || !range1.endTime || !range2.startTime || !range2.endTime) {
      return false;
    }

    const start1 = this.parseTimeString(range1.startTime);
    const end1 = this.parseTimeString(range1.endTime);
    const start2 = this.parseTimeString(range2.startTime);
    const end2 = this.parseTimeString(range2.endTime);

    // Check if ranges overlap: start1 < end2 && start2 < end1
    return start1 < end2 && start2 < end1;
  }

  // Validation method to check if at least one day is selected
  get hasSelectedDays(): boolean {
    return this.weekDays.some(day => day.selected);
  }

  // Check if there are overlapping time ranges within the current component
  hasInternalTimeOverlaps(): boolean {
    for (let i = 0; i < this.timeRanges.length; i++) {
      for (let j = i + 1; j < this.timeRanges.length; j++) {
        const range1 = this.timeRanges[i];
        const range2 = this.timeRanges[j];

        if (range1.startTime && range1.endTime && range2.startTime && range2.endTime) {
          if (this.timeRangesOverlap(range1, range2)) {
            return true;
          }
        }
      }
    }
    return false;
  }

  // Validation method to check if time range is valid (end time after start time)
  isValidTimeRange(timeRange: TimeRange): boolean {
    if (!timeRange.startTime || !timeRange.endTime) {
      return true; // Consider incomplete ranges as valid for now
    }

    const startTime = this.parseTimeString(timeRange.startTime);
    const endTime = this.parseTimeString(timeRange.endTime);

    // End time must be after start time (no overlapping within the same range)
    return endTime > startTime;
  }

  // Helper method to parse time string to minutes for comparison
  private parseTimeString(timeString: string): number {
    const timeMatch = timeString.match(/(\d+):(\d+)\s*(AM|PM)/);
    if (!timeMatch) {return 0;}

    let hour = parseInt(timeMatch[1], 10);
    const minute = parseInt(timeMatch[2], 10);
    const period = timeMatch[3];

    // Convert to 24-hour format
    if (period === 'PM' && hour !== 12) {
      hour += 12;
    }
    if (period === 'AM' && hour === 12) {
      hour = 0;
    }

    return hour * 60 + minute;
  }

  // Get filtered end time options based on start time
  getEndTimeOptions(timeRange: TimeRange): { value: string; display: string }[] {
    if (!timeRange.startTime) {
      return this.timeOptions;
    }

    const startTimeMinutes = this.parseTimeString(timeRange.startTime);
    const currentIndex = this.timeRanges.indexOf(timeRange);

    return this.timeOptions.filter(option => {
      const optionMinutes = this.parseTimeString(option.value);

      // Must be after the start time
      if (optionMinutes <= startTimeMinutes) {
        return false;
      }

      // Check if this end time would overlap with any other time range
      for (let i = 0; i < this.timeRanges.length; i++) {
        if (i === currentIndex) {continue;} // Skip current time range

        const otherRange = this.timeRanges[i];
        if (otherRange.startTime && otherRange.endTime) {
          const otherStartMinutes = this.parseTimeString(otherRange.startTime);
          const otherEndMinutes = this.parseTimeString(otherRange.endTime);

          // Check if the option time falls within another time range
          // or if the new range (startTime to option) would overlap with other range
          if ((optionMinutes > otherStartMinutes && optionMinutes <= otherEndMinutes) ||
              (startTimeMinutes < otherEndMinutes && optionMinutes > otherStartMinutes)) {
            return false;
          }
        }
      }

      return true;
    });
  }

  // Get filtered start time options that don't overlap with existing time ranges
  getStartTimeOptions(currentIndex: number): { value: string; display: string }[] {
    return this.timeOptions.filter(option => {
      const optionMinutes = this.parseTimeString(option.value);

      // Check if this start time would overlap with any other time range
      for (let i = 0; i < this.timeRanges.length; i++) {
        if (i === currentIndex) {continue;} // Skip current time range

        const otherRange = this.timeRanges[i];
        if (otherRange.startTime && otherRange.endTime) {
          const otherStartMinutes = this.parseTimeString(otherRange.startTime);
          const otherEndMinutes = this.parseTimeString(otherRange.endTime);

          // Check if the option time falls within another time range
          if (optionMinutes >= otherStartMinutes && optionMinutes < otherEndMinutes) {
            return false;
          }
        }
      }

      return true;
    });
  }

  getFormattedTime(hour: number, minute: number, period: 'AM' | 'PM'): string {
    if (!hour && hour !== 0) {
      return 'Input';
    }
    const paddedHour = hour.toString().padStart(2, '0');
    const paddedMinute = minute?.toString().padStart(2, '0') || '00';
    return `${paddedHour}:${paddedMinute} ${period}`;
  }

  onStartTimeChange(index: number) {
    const timeRange = this.timeRanges[index];
    if (timeRange.startTime) {
      // Parse the time string (e.g., "09:00 AM")
      const timeMatch = timeRange.startTime.match(/(\d+):(\d+)\s*(AM|PM)/);
      if (timeMatch) {
        let hour = parseInt(timeMatch[1], 10);
        const minute = parseInt(timeMatch[2], 10);
        const period = timeMatch[3] as 'AM' | 'PM';

        // Convert 12-hour to 24-hour for Date object
        if (period === 'PM' && hour !== 12) {
          hour += 12;
        }
        if (period === 'AM' && hour === 12) {
          hour = 0;
        }

        // Create a new date based on the current timeRange.start to preserve any existing date
        const date = new Date(timeRange.start);
        date.setHours(hour, minute, 0, 0);

        timeRange.hour = this.get12Hour(date);
        timeRange.minute = date.getMinutes();
        timeRange.period = period;
        timeRange.start = date;

        // Reset end time if it's now invalid (earlier than or equal to start time)
        if (timeRange.endTime) {
          const startTimeMinutes = this.parseTimeString(timeRange.startTime);
          const endTimeMinutes = this.parseTimeString(timeRange.endTime);

          if (endTimeMinutes <= startTimeMinutes) {
            timeRange.endTime = '';
            timeRange.endHour = 0;
            timeRange.endMinute = 0;
            timeRange.endPeriod = 'AM';
            const endDate = new Date(timeRange.end);
            endDate.setHours(0, 0, 0, 0);
            timeRange.end = endDate;
          }
        }
      }
    }

    // Ensure all properties are synchronized
    this.synchronizeTimeRangeProperties();
  }

  onEndTimeChange(index: number) {
    const timeRange = this.timeRanges[index];
    if (timeRange.endTime) {
      // Parse the time string (e.g., "05:00 PM")
      const timeMatch = timeRange.endTime.match(/(\d+):(\d+)\s*(AM|PM)/);
      if (timeMatch) {
        let hour = parseInt(timeMatch[1], 10);
        const minute = parseInt(timeMatch[2], 10);
        const period = timeMatch[3] as 'AM' | 'PM';

        // Convert 12-hour to 24-hour for Date object
        if (period === 'PM' && hour !== 12) {
          hour += 12;
        }
        if (period === 'AM' && hour === 12) {
          hour = 0;
        }

        // Create a new date based on the current timeRange.end to preserve any existing date
        const date = new Date(timeRange.end);
        date.setHours(hour, minute, 0, 0);

        timeRange.endHour = this.get12Hour(date);
        timeRange.endMinute = date.getMinutes();
        timeRange.endPeriod = period;
        timeRange.end = date;
      }
    }

    // Ensure all properties are synchronized
    this.synchronizeTimeRangeProperties();
  }
}
